import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class DestroyHelper {

  /*
   @Description : To unsubscribe all valid subscriptions
   @param : subscriptions - list of subscriptions
   */
  public unsubscribe(subscriptions: Subscription[]) {
    subscriptions.filter((subscription) => !!subscription)
      .forEach((subscription) => subscription.unsubscribe());
  }
}
